import { render, staticRenderFns } from "./aftersalesSettings.vue?vue&type=template&id=42aecfec&scoped=true"
import script from "./aftersalesSettings.vue?vue&type=script&lang=js"
export * from "./aftersalesSettings.vue?vue&type=script&lang=js"
import style0 from "./aftersalesSettings.vue?vue&type=style&index=0&id=42aecfec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aecfec",
  null
  
)

export default component.exports